import * as React from 'react';
import styled from 'styled-components';
import { useClipboard } from 'use-clipboard-copy';
import { ButtonStyles } from '@doltech/ui/lib/figma/Button/ButtonStyles/ButtonStyles';
import { ButtonSize } from '@doltech/ui/lib/figma/Button/ButtonSize/ButtonSize';
import { ButtonContentGeneral } from '@doltech/ui/lib/figma/Button/ButtonContentGeneral/ButtonContentGeneral';
import { IconSystemV2EssentialLinkChain } from '@doltech/icons/SystemV2/IconSystemV2EssentialLinkChain';
import { ButtonIconPrimaryStyles } from '@doltech/ui/lib/figma/Button/ButtonIconPrimaryStyles/ButtonIconPrimaryStyles';
import { ButtonIconPrimarySize } from '@doltech/ui/lib/figma/Button/ButtonIconPrimarySize/ButtonIconPrimarySize';

const Main = styled.div`
  display: grid;
  grid-auto-rows: max-content;
  gap: 2px;

  .text-link {
    justify-self: flex-start;
  }

  .btn-text {
    font-weight: 500;
  }
`;

interface CellCopyLinkProps extends React.HTMLAttributes<HTMLDivElement> {
  onCopyLink?: () => string;
  hasText?: boolean;
}

export const CopyLinkButton = (props: CellCopyLinkProps) => {
  const { onCopyLink, hasText } = props;
  const clipboard = useClipboard({
    copiedTimeout: 500,
  });

  if (hasText) {
    return (
      <Main className="copy-link-button">
        <ButtonStyles
          color="light"
          transparent
          onClick={() => {
            clipboard.copy(onCopyLink());
          }}
          content={
            <ButtonSize
              size="x-small"
              verticalPadding
              content={
                <ButtonContentGeneral
                  btnStyle="icon"
                  text="Copy link"
                  withLeftIcon
                  iconLeft={<IconSystemV2EssentialLinkChain/>}
                />
              }
            />
          }
        />
      </Main>
    );
  }

  return (
    <Main className="copy-link-button">
      <ButtonIconPrimaryStyles
        color="white"
        transparent
        content={
          <ButtonIconPrimarySize size="medium" icon={<IconSystemV2EssentialLinkChain/>}/>
        }
      />
    </Main>
  );
};

